import React from 'react';
import logoNative from './resource/logo_native.png'
import s from './navBarChoiceQuestion.module.css'

const NavBarChoiceQuestions = () => {
    return (

        <nav className={s.wrapper}>
        {/*<div className="nav-wrapper">*/}
        {/*    <div href="#" className={"brand-logo left " + s.logo}>Викторина</div>*/}
        {/*</div>*/}
            <img className={s.logoNative} src={logoNative} alt=""/>
          <div className={s.logo}>
              <div className={s.logo_up}>интерактивная развивающая игра</div>
              <div  className={s.logo_down}>РОССИЯ В ДЕТАЛЯХ</div>
          </div>
          <div className={s.poin_back} onClick={()=>{
                document.location.replace('/')
          }}>
              {'< Назад'}
          </div>
    </nav>

    );
};
//  <NavItem href="/">
//                     <Icon left>
//                         chevron_left
//                     </Icon>Выход в меню
//                 </NavItem>
export default NavBarChoiceQuestions;